import { useCallback } from 'react';
import DerechosHero from './components/DerechosHero';
import FonogramasModule from './components/FonogramasModule';
import AudiovisualesModule from './components/AudiovisualesModule';
import ComparativeTable from './components/ComparativeTable';

export default function DerechosPage() {
  const scrollTo = useCallback((slug: string) => {
    const el = document.getElementById(slug);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <main className="min-h-screen">
      <DerechosHero onScrollTo={scrollTo} />
      <FonogramasModule />
      <AudiovisualesModule />
      <ComparativeTable />

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in { animation: fade-in 0.8s ease-out both; }
        .animate-fade-in-delayed { animation: fade-in 0.8s ease-out 0.2s both; }
        .animate-fade-in-delayed-2 { animation: fade-in 0.8s ease-out 0.4s both; }
        .animate-fade-in-delayed-3 { animation: fade-in 0.8s ease-out 0.6s both; }
      `}</style>
    </main>
  );
}